__turbopack_context__.v({
  "buttonContainer": "TaxUnitsTab-module-scss-module__qpdEDG__buttonContainer",
  "container": "TaxUnitsTab-module-scss-module__qpdEDG__container",
  "desktopList": "TaxUnitsTab-module-scss-module__qpdEDG__desktopList",
  "header": "TaxUnitsTab-module-scss-module__qpdEDG__header",
  "mobileList": "TaxUnitsTab-module-scss-module__qpdEDG__mobileList",
  "noTaxUnitsLink": "TaxUnitsTab-module-scss-module__qpdEDG__noTaxUnitsLink",
  "noTaxUnitsText": "TaxUnitsTab-module-scss-module__qpdEDG__noTaxUnitsText",
});
